import apiRequest from './apiRequest';

export type MascotStatus =
  | 'VALIDATING'
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | 'FAILED'
  | 'CANCELLED'
  | 'REJECTED';

export type MascotJobResponse = {
  mascotID: string;
  mascotName?: string;
  status: MascotStatus;
  createdAt: string;
  updatedAt?: string;
  createdBy: string;
  estimatedSecondsWaitTime?: number;
  completedAt?: string;
  emailSubscribers?: string[];
  outputVideoURL?: string;
  downloadURL?: string;
  errorMessage?: string;
};

export default async function getMascot(mascotID: string, apiKey: string) {
  return await apiRequest<MascotJobResponse>(
    'external-mogen',
    `/mascot/${mascotID}`,
    {
      method: 'GET',
      headers: {
        'x-api-key': apiKey,
      },
    },
  );
}
